import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/wt-warehouse-in-history",
    name: "WarehouseInHistory",
    meta: {
      title: "入库历史",
      customBackFn: closeCurrentWebView,
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseInHistory.vue"
      )
  },
  {
    path: "/wt-warehouse-in-history-old",
    name: "WarehouseInHistoryOld",
    meta: {
      title: "入库历史-旧",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse-old/WarehouseInHistory.vue"
      )
  },
  {
    path: "/wt-warehouse-out-history",
    name: "WarehouseOutHistory",
    meta: {
      title: "出库历史",
      customBackFn: closeCurrentWebView,
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseOutHistory.vue"
      )
  },
  {
    path: "/wt-warehouse-out-history-old",
    name: "WarehouseOutHistoryOld",
    meta: {
      title: "出库历史-旧",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse-old/WarehouseOutHistory.vue"
      )
  },
  {
    path: "/wt-warehouse-in-history-search",
    name: "WarehouseInHistorySearch",
    meta: {
      title: "入库搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseInHistorySearch.vue"
      )
  },
  {
    path: "/wt-warehouse-in-history-search-old",
    name: "WarehouseInHistorySearchOld",
    meta: {
      title: "入库搜索-旧"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse-old/WarehouseInHistorySearch.vue"
      )
  },
  {
    path: "/wt-warehouse-out-history-search",
    name: "WarehouseOutHistorySearch",
    meta: {
      title: "出库搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseOutHistorySearch.vue"
      )
  },
  {
    path: "/wt-warehouse-out-history-search-old",
    name: "WarehouseOutHistorySearchOld",
    meta: {
      title: "出库搜索-旧"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse-old/WarehouseOutHistorySearch.vue"
      )
  },
  {
    path: "/wt-warehouse-batch-out-history",
    name: "WarehouseBatchOutHistory",
    meta: {
      title: "批量出库历史",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseBatchOutHistory.vue"
      )
  },
  {
    path: "/wt-warehouse-batch-out-history-search",
    name: "WarehouseBatchOutHistorySearch",
    meta: {
      title: "批量出库历史搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse" */ "@/views/warehouse/WarehouseBatchOutHistorySearch.vue"
      )
  },
  {
    path: "/wt-warehouse-exception",
    name: "WarehouseException",
    meta: {
      title: "异常记录",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse-exception" */ "@/views/warehouse/WarehouseException.vue"
      )
  },
  {
    path: "/wt-warehouse-exception-search",
    name: "WarehouseExceptionSearch",
    meta: {
      title: "异常记录搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse-exception" */ "@/views/warehouse/WarehouseExceptionSearch.vue"
      )
  },
  {
    path: "/wt-warehouse-stock",
    name: "WarehouseStock",
    meta: {
      title: "我的库存",
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse-stock" */ "@/views/warehouse/WarehouseStock.vue"
      )
  },
  {
    path: "/wt-warehouse-stock-search",
    name: "WarehouseStockSearch",
    meta: {
      title: "库存搜索"
    },
    component: () =>
      import(
        /* webpackChunkName: "warehouse-stock" */ "@/views/warehouse/WarehouseStockSearch.vue"
      )
  }
];
